module.exports = __webpack_public_path__ + "static/media/Lateral_End Stage_Z1.782a5cb4.png";